import { render, staticRenderFns } from "./CellRendererAvatar.vue?vue&type=template&id=5be4821f&"
import script from "./CellRendererAvatar.vue?vue&type=script&lang=js&"
export * from "./CellRendererAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports